import Alpine from "alpinejs";
import menu from "./menu";
import dropdown from "./dropdown";
import handleContactForm from "./handleContactForm";
import router from "./router";

Alpine.data("menu", menu);
Alpine.data("dropdown", dropdown);
Alpine.data("handleContactForm", handleContactForm);
Alpine.data("router", router);

Alpine.start();
